import type { NamePool } from "@/core/types.js";

export const frNamePool: NamePool = {
  given: {
    male: [
      "Jean", "Pierre", "Michel", "François", "André", "René", "Jacques",
      "Alain", "Bernard", "Philippe", "Christian", "Patrick", "Gilles",
      "Nicolas", "Thomas", "Julien", "Alexandre", "Mathieu", "Antoine",
      "Maxime", "Hugo", "Théo", "Raphaël", "Gabriel", "Lucas",
      "Louis", "Arthur", "Nathan", "Tom", "Ethan", "Nolan", "Baptiste",
      "Romain", "Clément", "Samuel",
    ],
    female: [
      "Marie", "Martine", "Françoise", "Hélène", "Sophie", "Isabelle",
      "Catherine", "Sylvie", "Brigitte", "Nicole", "Christine", "Michèle",
      "Nathalie", "Sandrine", "Valérie", "Céline", "Aurélie", "Stéphanie",
      "Laura", "Camille", "Sarah", "Emma", "Léa", "Chloé", "Manon",
      "Inès", "Juliette", "Jade", "Clara", "Lucie", "Anaïs", "Charlotte",
      "Mathilde", "Pauline", "Alice",
    ],
  },
  family: [
    "Martin", "Bernard", "Thomas", "Petit", "Robert", "Richard", "Durand",
    "Dubois", "Moreau", "Laurent", "Simon", "Michel", "Lefebvre", "Leroy",
    "Roux", "David", "Bertrand", "Morel", "Fournier", "Girard",
    "Bonnet", "Dupont", "Lambert", "Fontaine", "Rousseau", "Vincent",
    "Muller", "Lefevre", "Faure", "Andre", "Mercier", "Blanc",
    "Guerin", "Boyer", "Garnier", "Chevalier", "Francois", "Legrand",
    "Gauthier", "Garcia", "Perrin", "Robin", "Clement", "Morin",
    "Nicolas", "Henry", "Roussel", "Mathieu", "Gautier", "Masson",
  ],
};
